import { render, staticRenderFns } from "./BasePopUp.vue?vue&type=template&id=ba46f186&scoped=true&"
import script from "./BasePopUp.vue?vue&type=script&lang=js&"
export * from "./BasePopUp.vue?vue&type=script&lang=js&"
import style0 from "./BasePopUp.vue?vue&type=style&index=0&id=ba46f186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba46f186",
  null
  
)

export default component.exports